import { LOCAL_ENV_TARGET, USE_LOCAL_TARGET, getAppEnv } from './env';

const normalizeStage = (value) => String(value || '').trim().toLowerCase();

const rawStage = normalizeStage(getAppEnv('REACT_APP_STAGE'));

const stageFromNodeEnv = process.env.NODE_ENV === 'development' ? 'development' : 'production';

export const APP_STAGE = rawStage || (USE_LOCAL_TARGET ? LOCAL_ENV_TARGET : stageFromNodeEnv);
export const IS_BETA_STAGE = APP_STAGE === 'beta';
